<template>
  <section class="section">
    <div class="container">
      <div class="tabs is-right" id="menureportes">
        <ul>
          <router-link tag="li" :to="{ name: 'task.list' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Lista de Tareas</span>
            </a>
          </router-link>
          <!-- <router-link tag="li" :to="{ name: 'task.ticketlist' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Lista de Tickets</span>
            </a>
          </router-link> -->
          <router-link tag="li" :to="{ name: 'task.reports' }">
            <a>
              <span class="icon is-small">
                <span class="material-icons">list_alt</span>
              </span>
              <span>Reporte</span>
            </a>
          </router-link>
        </ul>
      </div>
      <div v-if="isinicial">
        <div class="notification">
          <h1 class="title is-4">Tareas</h1>
          <h2 class="subtitle is-6">Tareas de los diferentes proyectos</h2>

          <div class="content">
            <p>
              En este módulo podrá gestionar las tareas de los diferentes
              proyectos de yungol. <br />
              Tiene dos opciones de crear tareas.
            </p>
            <ul>
              <li>Crear tareas a partir de un ticket</li>
              <li>
                Crear tareas directamente desde el modulo de tareas sin
                necesidad de asociar un ticket.
              </li>
            </ul>
          </div>

          <br />
          <router-link
            tag="button"
            class="button is-link"
            :to="{ name: 'task.list' }"
          >
            <span class="icon is-small">
              <span class="material-icons">fact_check</span>
            </span>
            <span>Ver Tareas</span>
          </router-link>
        </div>
      </div>
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.tabs li.router-link-exact-active a {
  border-bottom-color: #3273dc;
  border-bottom-width: 2px;
  color: #3273dc;
}
</style>

<script>
import { mapState } from "vuex";
export default {
  data() {
    return {};
  },
  computed: {
    ...mapState(["tokenUser"]),
    isinicial() {
      return this.$route.name === "task";
    },
  },
  methods: {},
};
</script>

<style lang='scss'>
@media print {
  #menureportes {
    display: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/proyectos/task/MenuTask.vue